function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "vn_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.7,
  d: "M-85.3 0h682.6v512H-85.3z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipPath: "url(#vn_svg__a)",
  transform: "translate(80) scale(.9375)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ec0015",
  d: "M-128 0h768v512h-768z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff0",
  d: "M349.6 381L260 314.3l-89 67.3L204 272l-89-67.7 110.1-1 34.2-109.4L294 203l110.1.1-88.5 68.4 33.9 109.6z"
}));

var SvgVn = function SvgVn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480"
  }, props), _ref, _ref2);
};

export default SvgVn;